<template>
  <div>
    <v-row align="center">
      <v-col cols="3">
        <v-select v-model="event" :items="$t('evt')" chips label="Chips" multiple></v-select>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select
          v-model="company"
          :items="$store.getters['admin/companies']"
          item-value="idx"
          item-text="name"
          clearable
          :label="$t('fields.company')"
        />
      </v-col>
      <v-col cols="3">
        <DateRange v-model="dates" />
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :items="filteredEvents"
      :headers="headers"
      class="transparent"
      :page.sync="currentPage"
      show-expand
      item-key="idx"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:item.company="{item}">{{$store.getters['admin/company'](item.company).name}}</template>
      <template v-slot:item.created="{item}">{{item.created|dt-time}}</template>
      <template v-slot:item.type_="{item}">{{$t('evt')[item.type_].text}}</template>
      <template v-slot:expanded-item="{headers, item}">
        <td :colspan="headers.length">
          <v-row>
            <v-col v-for="(v,k) in item.message" :key="k" cols="4">
              <div class="subtitle-2">{{k}}</div>
              <div>{{v}}</div>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "Events",
  components: { DateRange },
  mixins: [commonmixin],
  data() {
    return {
      event: [],
      headers: [
        { text: this.$t("fields.created"), value: "created" },
        { text: this.$t("fields.company"), value: "company" },
        { text: this.$t("fields.event"), value: "type_" },
        { text: this.$t("fields.task"), value: "task" },
        { text: this.$t("fields.user"), value: "username" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  computed: {
    filteredEvents() {
      if (this.dates.length == 2) {
        return this.items.filter((e) => {
          if (this.company && this.company != e.company) return false;
          const d0 = this.$moment(e.created);
          let d1 = this.$moment(this.dates[0]);
          let d2 = this.$moment(this.dates[1]);
          if (d1.isAfter(d2)) {
            d1 = this.$moment(this.dates[1]);
            d2 = this.$moment(this.dates[0]);
          }
          let res =
            d0.isAfter(d1.startOf("day")) &&
            d0.isBefore(d2.endOf("day")) &&
            (!this.event.length ||
              this.event.indexOf(e.type_.toString()) != -1);
          return res;
        });
      } else {
        return this.items.filter((e) => {
          if (this.company && this.company != e.company) return false;
          return (
            !this.event.length || this.event.indexOf(e.type_.toString()) != -1
          );
        });
      }
    },
  },
  methods: {
    loadData() {
      this.$api.getEvents().then((response) => {
        this.items = response;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
</style>